import { type ReactNode } from 'react';

import { Text } from '../../../../../../../../components/ToolkitV2/Text/Text';
import { ListInline } from '../../../../../../../../components/ToolkitV2/ListInline/ListInline';

import * as Styled from './VehicleDetails.styled';

import { type Spacing, Spacer } from 'helpers/genericStyles';

import { ORIENTATION } from '../../../../../../../../components/ToolkitV2/CardV2/Card.typed';
import { ListInlineSeparator } from '../../../../../../../../components/ToolkitV2/ListInline/ListInline.typed';

type VehicleDetailsProps = {
  name: string;
  details: Array<string>;
  footer?: ReactNode;
} & Spacing;

const VehicleDetails = (props: VehicleDetailsProps) => {
  const { name, details, footer, mb } = props;

  return (
    <Styled.VehicleDetailsCard
      header={
        <div>
          <Text forwardedAs="h3" size="M16" weight="bold">
            Your {name}
          </Text>
          <Spacer marginBottom="S4" />
          <ListInline
            separator={ListInlineSeparator.BULLET}
            keyName="vehicle-list-item-"
          >
            {details}
          </ListInline>
        </div>
      }
      footer={footer}
      orientationSmall={ORIENTATION.HORIZONTAL}
      paddingSmall="M16"
      gapSmall="M16"
      mb={mb}
    />
  );
};

export { VehicleDetails };
